import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    url: '',
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  containerDesign: {},
};

export const twitterSlice = createSlice({
  name: 'twitter',
  initialState,
  reducers: {
    twitterStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        url: blockContent.url ?? '',
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
    },
    twitterClear: () => initialState,

    twitterUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    twitterUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    twitterUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { twitterStore, twitterClear, twitterUpdateIsLoading, twitterUpdateIsActive, twitterUpdateBlockContent } = twitterSlice.actions;

export const selectTwitterIsLoading = (state) => state.twitter.isLoading;

export const selectTwitterId = (state) => state.twitter.id;
export const selectTwitterUID = (state) => state.twitter.uid;
export const selectTwitterSID = (state) => state.twitter.sid;

export const selectTwitterBlockContent = (state) => state.twitter.blockContent;
export const selectTwitterContainerDesign = (state) => state.twitter.containerDesign;

export default twitterSlice.reducer;
